import { FC, ReactNode } from 'react';
import cs from 'classnames';
import styles from './index.module.less';

/**
 * 各模块
 * @description
 * @demo
 */
const Component:FC<{
  children?: ReactNode,
  className?: string,
}> = ({ children, className }) => {

  /* state */

  /* hooks */

  /* methods */

  return (<div className={cs(styles.block, className)}>{children}</div>);
};

export default Component;
